// PARAQTA — Офлайн кезек (durable outbox).
//
// Мәселе: оқуды аяқтағанда интернет үзілсе, `/api/sessions/save` құлайтын да,
// адамның 25 минуты мен оқыған беті ЖОҒАЛАТЫН («Сақтау сәтсіз» деп қана
// шығатын). Қазақстанда метро/дала/әлсіз байланыс — жиі жағдай.
//
// Шешім: сәтсіз жазуды localStorage-ға САҚТАЙМЫЗ да, интернет қайтқанда
// автоматты жібереміз. Сервер жағы idempotent (бір сессия екі рет
// есептелмейді) — сондықтан қайта жіберу қауіпсіз.

const KEY = 'pq_outbox_v1';
const MAX_ITEMS = 30;
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;    // 7 күннен ескісін тастаймыз
let _timer = null;
let _flushing = false;

function _read() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; }
}
function _write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX_ITEMS))); } catch (_) {}
}

/** Сәтсіз жазуды кезекке қою. key берілсе — сол кілтпен қайталама болмайды. */
export function enqueue(url, body, key) {
  const list = _read().filter(x => !(key && x.key === key));
  list.push({ url, body, key: key || '', at: Date.now(), tries: 0 });
  _write(list);
  schedule(1500);
}

/** Кезекте не бар (UI көрсету үшін). */
export function pending() {
  return _read().length;
}

async function _send(item) {
  const r = await fetch(item.url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: typeof item.body === 'string' ? item.body : JSON.stringify(item.body),
  });
  // 4xx (401/400) — қайталаудың мәні жоқ, тастаймыз. 5xx/желі — қайталаймыз.
  if (r.status >= 400 && r.status < 500) return 'drop';
  if (!r.ok) return 'retry';
  return 'ok';
}

/** Кезекті жіберіп көру. */
export async function flush() {
  if (_flushing) return;
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
  const list = _read();
  if (!list.length) return;
  _flushing = true;
  const keep = [];
  for (const item of list) {
    if (Date.now() - (item.at || 0) > MAX_AGE_MS) continue;   // тым ескі
    let res = 'retry';
    try { res = await _send(item); } catch (_) { res = 'retry'; }
    if (res === 'retry') {
      item.tries = (item.tries || 0) + 1;
      if (item.tries < 25) keep.push(item);
    }
  }
  _write(keep);
  _flushing = false;
  if (keep.length) schedule(60000);      // әлі қалса — бір минуттан соң
}

function schedule(ms) {
  clearTimeout(_timer);
  _timer = setTimeout(flush, ms);
}

/** Бет ашылғанда + интернет қайтқанда автоматты жіберу. */
export function initOfflineQueue() {
  if (typeof window === 'undefined') return;
  window.addEventListener('online', () => schedule(600));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) schedule(1200);
  });
  schedule(2500);                        // бет жүктелген соң
}
